import { Component, DoCheck, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { HealthSystemSetup } from 'src/app/core/model/v2/practice/HealthSystemSetup';
import { UserSetup } from 'src/app/core/model/v2/practitioner/UserSetup';
import { CommonService } from 'src/app/core/services/v2/common.service';
import { SideBarInitializeParameters } from 'src/app/shared/components/dynamic-right-sidebar/SideBarInitializeParameters';
import { PracticeManagerFormComponent } from '../../profiles/practice-manager-form/practice-manager-form.component';


@Component({
  selector: 'app-practice-summary',
  templateUrl: './practice-summary.component.html',
  styleUrls: ['./practice-summary.component.scss']
})
export class PracticeSummaryComponent implements OnInit, OnChanges {

  @Input()
  healthSystem: HealthSystemSetup;

  @Output()
  practiceManagerUpdated: EventEmitter<any> = new EventEmitter();

  changed: boolean;

  onClosePracticeManagerSideBar: EventEmitter<any> = new EventEmitter();

  constructor(private commonService: CommonService) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.healthSystem = changes["healthSystem"].currentValue

    this.changed = true;
  }

  ngOnInit() {
    this.onClosePracticeManagerSideBar.subscribe( _ => this.practiceManagerUpdated.emit());
  }

  AddPracticeManager()
  {
    const addPracticeManagerData = <SideBarInitializeParameters> {
      componentType: PracticeManagerFormComponent, 
      data : {hsid: this.healthSystem.id},
      onClose : this.onClosePracticeManagerSideBar
    };
    this.commonService.rightSideBarComponent$.next(addPracticeManagerData);
  }
  EditPracticeManager()
  {
    const addPracticeManagerData = <SideBarInitializeParameters> {
      componentType: PracticeManagerFormComponent, 
      data : {hsid: this.healthSystem.id, currentManager: this.healthSystem.practiceManagerUser} ,
      onClose : this.onClosePracticeManagerSideBar
    };
    this.commonService.rightSideBarComponent$.next(addPracticeManagerData);
  }


}
